import { FC } from 'react';
import { Button, Typography, Divider } from '@mui/material';

import { useAuthDeleteAccountMutation } from '@carcareers/store';
import { useNavigate } from 'react-router-dom';
import { useAuth, useConfirmation } from '@carcareers/contexts';
import { routes } from '@carcareers/utils';

interface DeleteAccountActionProps {
  type?: 'jobseeker' | 'employer';
}

export const DeleteAccountAction: FC<DeleteAccountActionProps> = ({ type = 'employer' }) => {
  const { clearSession } = useAuth();
  const [deleteAccount, { isLoading }] = useAuthDeleteAccountMutation();
  const navigate = useNavigate();
  const { confirm } = useConfirmation();

  const handleDeleteAccount = async () => {
    const confirmed = await confirm({
      title: 'Delete Account',
      message: 'Are you sure you want to delete your account? This action is irreversible.',
    });

    if (confirmed) {
      await deleteAccount();
      clearSession();
      navigate(`/${routes.LOGIN}`, { replace: true, state: { isAccountDeactivated: true } });
    }
  };

  const message = type === 'employer' ? (
    <Typography>
    Caution! This action is irreversible. All your data will be permanently
      deleted. Job postings where you are the owner of the rooftop will be
      closed. Applicants will no longer be able to apply to your job postings.
      You will no longer be able to access your account.
    </Typography>
  ) : (
    <Typography>
      Caution! This action is irreversible. All your data will be permanently
      deleted. You will no longer be able to access your account.
    </Typography>
  );

  return (
    <>
      <Divider />
      <Typography variant="h6">Delete your account</Typography>
      {message}
      <Button
        onClick={handleDeleteAccount}
        variant="outlined"
        color="error"
        disabled={isLoading}
        loading={isLoading}
        sx={{ width: 'fit-content', alignSelf: 'flex-end' }}
      >
        Delete Account
      </Button>
    </>
  );
};

export default DeleteAccountAction;